export interface RequestParams<T> {
  searchText?: string;
  page?: number;
  pageSize?: number;
  sort?: string;
  filter?: T;
  with?: string | string[];
}

export interface ServicePagination {
  count: number;
  currentPage: number;
  links: { next: string; previous: string };
  perPage: number;
  total: number;
  totalPages: number;
}

export interface ServiceResponse<T> {
  data: T;
  status: number;
  success: boolean;
}

export interface PaginatedServiceResponse<T> extends ServiceResponse<T> {
  pagination: ServicePagination;
}

export const ERROR_CODE = {
  pendingEmailVerification: "pending_email_verification",
  pendingIntakeForm: "pending_intake_form",
  magicLinkExpired: "magic_link_expired",
} as const;

export type ErrorCode = (typeof ERROR_CODE)[keyof typeof ERROR_CODE];
